import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {GlossaryInfoModal} from 'shells/glossary-info-modal/glossary-info-modal';
import {Body} from 'shells/typography/body';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

export function CompetitorIqInfoModal() {
    const {onClose} = useOpenableModal(OpenableModals.COMPETITOR_IQ_INFO_MODAL);

    return (
        <GlossaryInfoModal
            onClose={onClose}
            artImage={
                <img
                    src='/include/images/onboarding/competitor-iq-ball-roll.svg'
                    alt='CompetitorSpy'
                />
            }
            title='Elevate your insights with CompetitorSpy'
            body={
                <>
                    <Body>
                        Gain an edge over your top 5 competitors with detailed competitive analysis
                    </Body>
                    <p>
                        <BulletedList
                            bullets={[
                                <span key='bullet-1'>
                                    Dive into CompetitorSpy to gain a deeper understanding of your
                                    rivals’ web traffic sources.
                                </span>,
                                <span key='bullet-2'>
                                    Decode & monitor the strategies driving your competitors’ online
                                    success.
                                </span>,
                                <span key='bullet-3'>
                                    Navigate the dynamic landscape with insights into competitors’
                                    web traffic trends.
                                </span>,
                            ]}
                        />
                    </p>
                </>
            }
            learnEvenMoreHref='https://www.nutshell.com/competitoriq'
        />
    );
}
